import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class SalesTaxReturnListItem extends SearchModelBase {
    void: boolean | null = null;
    postDate: string | null = null;
    fromPostDate: string | null = null;
    toPostDate: string | null = null;
    branch: string = '';
    refNo: string = '';
    entity: string = '';
    accountType: string = '';
    currency: string = '';
    amount: number|null = null;
    fromAmount: number|null = null;
    toAmount: number|null = null;
    paidAmount: number|null = null;
    fromPaidAmount: number|null = null;
    toPaidAmount: number|null = null;
    balance: number|null = null;
    fromBalance: number|null = null;
    toBalance: number|null = null;
    id: number = 0;
    u1Date: string | null = null;
    fromU1Date: string | null = null;
    toU1Date: string | null = null;
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    u2ID: string = '';
    u1ID: string = '';
    status: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        // XCol.Create({ col: 1, text: 'V', width: 40, dataIndex: 'void', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 2, text: 'Date', width: 75, dataIndex: 'postDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 3, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'Ref. #', width: 100, dataIndex: 'refNo', defaultColumnFocus : true}),
        XCol.Create({ col: 5, text: 'Entity', width: 150, dataIndex: 'entity'}),
        XCol.Create({ col: 6, text: 'Account Type', width: 100, dataIndex: 'accountType'}),
        XCol.Create({ col: 7, text: 'CUR', width: 40, dataIndex: 'currency', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 8, text: 'Amount', width: 100, dataIndex: 'amount', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 9, text: 'Paid Amount', width: 100, dataIndex: 'paidAmount', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 10, text: 'Balance', width: 100, dataIndex: 'balance', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 11, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 12, text: 'Create by', width: 80, dataIndex: 'u1ID'}),
        XCol.Create({ col: 13, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 14, text: 'Update by', width: 80, dataIndex: 'u2ID'}),
        ];


    public static getExportCollection(useBranch: boolean): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
        return returnCloumns;
    };
	
    public static OrderBy = { orderBy: SalesTaxReturnListItem.prototype.postDate, orderByAscending: false };

    public static formatData(data: SalesTaxReturnListItem[]) {
        return data.map((d: SalesTaxReturnListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        postdate: {from: 'fromPostdate', to: 'toPostdate'},
        u1Date: {from: 'fromU1Date', to: 'toU1Date'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
        amount: {from: 'fromAmount', to: 'toAmount'},
        paidAmount: {from: 'fromPaidAmount', to: 'toPaidAmount'},
        balance: {from: 'fromBalance', to: 'toBalance'},
    }
}
